import Container from "../../../../components/container";
import { CharityIssueCategory } from "../../../../models";
import { DeleteButton, UpdateButton } from "./buttons";

export default function CharityIssueCategoriesTable({
  categories,
}: {
  categories: CharityIssueCategory[];
}) {
  return (
    <Container className="max-w-xl  text-left">
      <table className="min-w-full text-gray-900 text-left ">
        <thead className="rounded-lg text-left text-sm font-normal">
          <tr>
            <th scope="col" className="px-6 py-3">
              Name
            </th>

            <th scope="col" className="px-6 py-3">
              <span className="sr-only">Edit</span>
            </th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {categories.map((category) => (
            <tr
              key={category.id}
              className="w-full text-left border-b py-3 text-sm last-of-type:border-none [&:first-child>td:first-child]:rounded-tl-lg [&:first-child>td:last-child]:rounded-tr-lg [&:last-child>td:first-child]:rounded-bl-lg [&:last-child>td:last-child]:rounded-br-lg"
            >
              <td className="whitespace-nowrap px-6 py-3">{category.name}</td>

              <td className="px-6 py-4">
                {category.id ? (
                  <div className="flex flex-1 items-center justify-end gap-2">
                    <UpdateButton id={category.id} />
                    <DeleteButton id={category.id} />
                  </div>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Container>
  );
}
